import { createModel } from "@rematch/core";
import type { RootModel } from ".";
import { Tag } from "../types/tags.types";

export interface TagStoreProps {
    items: Tag[];
    loading: {
        fetchAll: boolean;
        updateTag: boolean;
        createTag: boolean;
        deleteTag: boolean;
    };
}

export const tagInitialState: TagStoreProps = {
    items: [],
    loading: {
        fetchAll: false,
        updateTag: false,
        createTag: false,
        deleteTag: false
    },
};

export const tags = createModel<RootModel>()({
    state: tagInitialState,
    reducers: {
        toggleLoading: (store, prop: keyof TagStoreProps["loading"], v: boolean) => ({
            ...store,
            loading: {
                ...store.loading,
                [prop]: v,
            },
        }),
        setTags: (store, items: Tag[]) => ({
            ...store,
            items,
        }),
        createTagInStore: (store, newTag: Tag) => ({
            ...store,
            items: [...store.items, newTag],
        }),
        updateTagInStore: (store, updatedTag: Tag) => ({
            ...store,
            items: store.items.map(tag =>
                tag._id === updatedTag._id ? updatedTag : tag
            ),
        }),
    },
});
